/* StudioSoie · Pages du pied de page — scripts communs
   - liens « chat » : ouvrent le chat AI Solver (porte choisie) s'il est actif, sinon repli (URL + libellé)
   - blocs [data-ss-chat-only] : affichés seulement si le chat est actif
   - FAQ : accordéon, onglets, recherche
   - Journal : défilement infini du fil */
(function () {
  'use strict';
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Chat ou repli ---- */
  function chat() { return window.SSChatInstance && typeof window.SSChatInstance.open === 'function' ? window.SSChatInstance : null; }
  function openDoor(door) {
    var c = chat(); if (!c) { return false; }
    try {
      c.open();
      if (door && typeof c.enter === 'function' && !(c.state && c.state.door)) {
        if (typeof c.clearChoices === 'function') { c.clearChoices(); }
        c.enter(door);
      }
    } catch (e) {}
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ss-chat-link]');
    if (!a || a.getAttribute('data-ss-fell-back') === '1') { return; }
    if (openDoor(a.getAttribute('data-ss-chat-door'))) { e.preventDefault(); }
  });
  function settle() {
    var on = !!chat();
    qsa('[data-ss-chat-only]').forEach(function (el) { el.hidden = !on; });
    if (!on) {
      qsa('[data-ss-chat-link]').forEach(function (a) {
        var fb = a.getAttribute('data-ss-fallback'); if (!fb) { return; }
        a.setAttribute('href', fb); a.setAttribute('data-ss-fell-back', '1');
        var lbl = a.getAttribute('data-ss-fallback-label'); if (lbl) { a.textContent = lbl; }
      });
    }
  }
  var tries = 0;
  (function wait() { if (chat() || tries++ > 12) { settle(); return; } setTimeout(wait, 250); })();

  /* ---- FAQ ---- */
  qsa('[data-ss-faq]').forEach(function (root) {
    var bar = root.querySelector('.ss-faq-bar'), searchEl = root.querySelector('.ss-faq-search__input'), clearBtn = root.querySelector('.ss-faq-search__clear');
    var tabs = qsa('.ss-faq-tab', root), allItems = qsa('.ss-faq-item', root), allCats = qsa('.ss-faq-category', root);
    var emptyEl = root.querySelector('.ss-faq-empty'), rcEl = root.querySelector('.ss-faq-rc'), content = root.querySelector('.ss-faq-content');
    var activeFilter = '', RESULTS = root.getAttribute('data-results-label') || '';
    if (bar) {
      var sentinel = document.createElement('div'); sentinel.style.height = '1px'; sentinel.style.pointerEvents = 'none';
      bar.parentNode.insertBefore(sentinel, bar);
      if (window.IntersectionObserver) { new IntersectionObserver(function (en) { bar.classList.toggle('ss-is-stuck', !en[0].isIntersecting); }).observe(sentinel); }
    }
    allItems.forEach(function (item) {
      var btn = item.querySelector('.ss-faq-item__trigger'), body = item.querySelector('.ss-faq-item__body');
      if (!btn || !body) { return; }
      btn.addEventListener('click', function () {
        if (item.classList.contains('ss-is-open')) {
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.maxHeight = '0'; });
          item.classList.remove('ss-is-open'); btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('ss-is-open'); btn.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
          body.addEventListener('transitionend', function cb() { body.style.maxHeight = 'none'; body.removeEventListener('transitionend', cb); });
        }
      });
    });
    function applyFilter() {
      var q = searchEl ? searchEl.value.trim().toLowerCase() : '', hasQ = q.length >= 1, vis = 0;
      allCats.forEach(function (cat) {
        var slug = cat.getAttribute('data-cat');
        if (!(activeFilter === '' || slug === activeFilter)) { cat.style.display = 'none'; return; }
        var catVis = 0;
        qsa('.ss-faq-item', cat).forEach(function (item) {
          var show = !hasQ || (item.getAttribute('data-q') || '').indexOf(q) !== -1;
          item.classList.toggle('ss-faq-item--hidden', !show);
          if (show) { catVis++; vis++; }
        });
        cat.style.display = catVis > 0 ? '' : 'none';
      });
      if (emptyEl) { emptyEl.classList.toggle('ss-visible', vis === 0 && (hasQ || activeFilter !== '')); }
      if (rcEl) { if (hasQ) { rcEl.textContent = vis + ' ' + RESULTS; rcEl.classList.add('ss-visible'); } else { rcEl.classList.remove('ss-visible'); } }
    }
    function setActiveTab(tab) {
      tabs.forEach(function (t) { t.classList.remove('ss-is-active'); t.setAttribute('aria-selected', 'false'); });
      tab.classList.add('ss-is-active'); tab.setAttribute('aria-selected', 'true');
      activeFilter = tab.getAttribute('data-cat') || '';
    }
    var allTab = root.querySelector('.ss-faq-tab[data-cat=""]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (searchEl) { searchEl.value = ''; }
        if (clearBtn) { clearBtn.classList.remove('ss-visible'); }
        setActiveTab(tab); applyFilter();
        if (content) { var offset = bar ? bar.offsetHeight + 16 : 80; var top = content.getBoundingClientRect().top + window.scrollY - offset; window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); }
      });
    });
    if (searchEl) {
      searchEl.addEventListener('input', function () {
        if (clearBtn) { clearBtn.classList.toggle('ss-visible', this.value.length > 0); }
        if (allTab) { setActiveTab(allTab); }
        applyFilter();
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (searchEl) { searchEl.value = ''; }
        clearBtn.classList.remove('ss-visible');
        if (allTab) { setActiveTab(allTab); }
        applyFilter(); if (searchEl) { searchEl.focus(); }
      });
    }
  });

  /* ---- Journal : fil sans fin ---- */
  qsa('[data-ssj-root]').forEach(function (root) {
    var feed = root.querySelector('[data-ssj-feed]'), loader = root.querySelector('[data-ssj-loader]'), loading = false, io;
    if (!feed) { return; }
    function sentinel() { return root.querySelector('[data-ssj-sentinel]'); }
    function loadNext() {
      var s = sentinel(); if (!s || loading) { return; }
      var url = s.getAttribute('data-next'); if (!url) { return; }
      loading = true; if (loader) { loader.classList.add('is-on'); }
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-ssj-feed] .ssj-card').forEach(function (c) { c.querySelectorAll('img[loading="eager"]').forEach(function (i) { i.loading = 'lazy'; i.removeAttribute('fetchpriority'); }); feed.appendChild(document.importNode(c, true)); });
          var ns = doc.querySelector('[data-ssj-sentinel]'); s.remove();
          if (ns) { feed.parentNode.insertBefore(ns, loader); observe(); }
          else { var end = doc.querySelector('.ssj-end'); if (end) { feed.parentNode.insertBefore(document.importNode(end, true), loader); } }
          loading = false; if (loader) { loader.classList.remove('is-on'); }
        })
        .catch(function () { loading = false; if (loader) { loader.classList.remove('is-on'); } });
    }
    function observe() {
      var s = sentinel(); if (!s) { return; }
      if (!('IntersectionObserver' in window)) { loadNext(); return; }
      if (io) { io.disconnect(); }
      io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { loadNext(); } }); }, { rootMargin: '600px 0px' });
      io.observe(s);
    }
    observe();
  });
})();
